module.exports = __webpack_public_path__ + "static/media/Santa Rosa Avenue, Santa Barbara, CA1.8a5db9df.jpg";